var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.moduleLoadingFour)?_c('div',[_c('BaseComponentLoader')],1):_c('div',[(_vm.schema != null)?_c('ActualGenerateProductForm',{attrs:{"theSchema":_vm.schema}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }